// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"d9afea20","776":"ddeb98a3","894":"aa5d1ae1"}[chunkId] + ".chunk.js";
};